<mat-dialog-content>
    <p mat-dialog-title class="title">{{'label.generateNewQr'|translate}}</p>
    <p mat-dialog-content class="description">{{'label.newQRQuestion'|translate}}</p>
    <div class="d-none">
        <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="bodyQR"  id="print-section-dialog"></ngx-qrcode>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button (click)="print()" class="accept pr-5">
        {{'button.acceptPrint'|translate}}
    </button>
    <button class="cancel" mat-dialog-close (click)="cancel()">{{'button.cancel'|translate}}</button>
    <button class="accept" mat-dialog-close (click)="accept()">
        {{'button.accept'|translate}}
    </button>
</mat-dialog-actions>